import { SysAircraftMake } from 'app/core/models/sys-aircraft-make.model';
import { SysAircraftModel } from 'app/core/models/sys-aircraft-model.model';
import { Aircraft } from 'app/features/settings/models/aircraft.model';
import { SysApuModel } from 'app/features/settings/models/sys-apu-model.model';

export interface AircraftState {
  aircrafts: Aircraft[];
  aircraftMakes: SysAircraftMake[];
  aircraftModels: SysAircraftModel[];
  apuModels: SysApuModel[];
  loading: boolean;
  error: string;
}

export const initialAircraftState: AircraftState = {
  aircrafts: [],
  aircraftMakes: [],
  aircraftModels: [],
  apuModels: [],
  loading: false,
  error: '',
};
